import { ParameterData } from '@/features/ocr/types/ParameterData';
import { BASE_URL } from '@/utils/Constants';
import { useAuth } from '@/utils/stores/useAuthStore';
import { useQuery } from '@tanstack/react-query';
export const getParameters = async (userId: string, token: string) => {
  const response = await fetch(
    `${BASE_URL}/api/anamnestic-data/data-points/user/${userId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  const data = (await response.json()) as ParameterData[];
  if (!response.ok) {
    throw new Error('Failed to fetch parameters');
  }

  // sort data by date
  data.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  return data;
};

export const useGetParameters = () => {
  const { userId, idToken } = useAuth();
  return useQuery<ParameterData[]>({
    queryKey: ['parameters', userId, idToken],
    queryFn: () => getParameters(userId!, idToken!),
    enabled: !!userId && !!idToken,
  });
};
